// En la vista previa estática (NEXT_PUBLIC_EXPORT=1) los enlaces son relativos y sin navegación de cliente,
// para que el sitio funcione dentro de cualquier carpeta. En producción es un Link normal de Next.
import Link from "next/link";
import type { ComponentProps } from "react";

export const rutaExport = (href: string) => {
  if (!href.startsWith("/")) return href;
  const [ruta, hash] = href.split("#");
  const [camino, query] = ruta.split("?");
  const limpio = camino.replace(/^\//, "").replace(/\/?$/, "/") + "index.html";
  return limpio + (query ? `?${query}` : "") + (hash ? `#${hash}` : "");
};

export function Enlace({ href, ...resto }: ComponentProps<typeof Link> & { href: string }) {
  if (process.env.NEXT_PUBLIC_EXPORT === "1") return <a href={rutaExport(href)} {...(resto as ComponentProps<"a">)} />;
  return <Link href={href} {...resto} />;
}
